import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/messaging';

import { firebaseConfig, FIREBASE_PERMISSION_ERROR } from 'constants/firebaseConfig';

firebase.initializeApp(firebaseConfig);

export const isNotificationsEnabled = false;
export const isNotificationsSupported = isNotificationsEnabled && firebase.messaging.isSupported();
const messaging = isNotificationsSupported && firebase.messaging();

//messaging.usePublicVapidKey(firebaseConfig.publicKey);

export const firebaseMessaging = () => messaging;

export const getFcmToken = () => new Promise(resolve => (
    firebaseMessaging().getToken()
        .then(currentToken => {
            resolve(currentToken);
        })
        .catch(() => resolve(''))
));

export const getFcmNewToken = () => new Promise(resolve => (
    firebaseMessaging().getToken()
        .then(oldToken => {
            const getToken = () => firebaseMessaging().getToken().then(resolve);

            oldToken ? firebaseMessaging().deleteToken(oldToken).then(getToken) : getToken();
        })
        .catch(() => resolve(''))
));

export const deleteToken = () => getFcmToken().then(
    token => token && (
        firebaseMessaging().deleteToken(token)
    )
);

export const getPermission = () => firebaseMessaging().requestPermission();

export const isNotificationError = (error) => error.code === FIREBASE_PERMISSION_ERROR;
